import { useLang } from "../i18n/i18n";

export const SectionHeading = ({ eyebrow, title, description, idx, align = "left" }) => {
  const { t } = useLang();
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {(eyebrow || idx) && (
        <div className="flex items-center gap-3 mb-6">
          {idx && (
            <span className="mono text-[11px] tracking-[0.2em] uppercase text-[#9CA3AF]">
              {idx}
            </span>
          )}
          {eyebrow && (
            <>
              <span className="w-6 h-px bg-[#0B1F3A]" />
              <span className="eyebrow">{t(eyebrow)}</span>
            </>
          )}
        </div>
      )}
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-[#0B1F3A] leading-[1.05]">
        {t(title)}
      </h2>
      {description && (
        <p className="mt-5 text-[#4B5563] text-base md:text-[17px] leading-relaxed max-w-2xl">
          {t(description)}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
